import { useSelector } from "react-redux";
import { RootState } from "../common/commonTypes";

export const useOrgCapabilities = (orgId: number) => 
  useSelector((state: RootState) => {
    return orgId ?  state.capabilitiesByOrgId[orgId] : [];
});